<template>
  <div style="padding: 20px; height: 100%;">
    <ul id="water-data">
      <li v-for="(items,index) in waterData" :key="items[index]" :style="liStyle(index)">
        <p>
          <span :class="index == 0 ? 'iconfont icon-droplet' : 'iconfont icon-stats-bars2'" style="font-size: 20px; color: white;"></span>
          <span>{{index == 0 ? '抄见数据' : '用水统计'}}</span>
        </p>
        <p :id="content.id" v-for="content in items" :key="content.id">
          <span>{{content.name}}</span>
          <span>{{content.data}}</span>
        </p>
      </li>
    </ul>
    <div id="dataChart">
    </div>
  </div>
</template>

<script>
import Echarts from 'echarts'
import { fetch } from '@/utils/api'

export default {
  name: 'waterStatisticsSummary',
  components: {
    Echarts
  },
  data () {
    return {
      bgColor: ['rgb(100, 162, 219)', 'rgb(100, 195, 199)'],
      tabHeight: document.body.clientHeight - 250,
      tabWidth: document.body.clientWidth - 500,
      dCharts: {},
      waterData: {
        '0': [
          {
            id: 'subdistCount',
            name: '小区总数',
            data: 0
          },
          {
            id: 'count',
            name: '用户总数',
            data: 0
          },
          {
            id: 'ldReadRate',
            name: '昨日抄见率',
            data: '0%'
          },
          {
            id: 'mReadRate',
            name: '月抄见率',
            data: '0%'
          }
        ],
        '1': [
          {
            id: 'ldWaterConsumption',
            name: '昨日用水量',
            data: 0
          },
          {
            id: 'lmWaterConsumption',
            name: '本月用水量',
            data: 0
          },
          {
            id: 'monthWaterConsumption',
            name: '上月用水量',
            data: 0
          }
        ]
      },
      // echartOptions: {
      //   title: {
      //     text: '图表统计数据',
      //     left: 'center',
      //     textStyle: {
      //       fontSize: 20
      //     }
      //   },
      //   tooltip: {
      //     trigger: 'item',
      //     formatter: '{a} <br/>{b}: {c} ({d}%)'
      //   },
      //   legend: {
      //     data: ['昨日用水量', '本月用水量', '上月用水量', '月抄见率', '月异常率'],
      //     top: 50,
      //     textStyle: {
      //       fontSize: 15
      //     }
      //   },
      //   series: [
      //     {
      //       name: '抄见比例',
      //       type: 'pie',
      //       selectedMode: 'single',
      //       radius: [0, '15%'],
      //       label: {
      //         normal: {
      //           position: 'inner',
      //           fontSize: 16
      //         }
      //       },
      //       labelLine: {
      //         normal: {
      //           show: false
      //         }
      //       },
      //       data: [
      //         {value: 0, name: '月抄见率'},
      //         {value: 0, name: '月异常率'}
      //       ]
      //     },
      //     {
      //       name: '用水统计',
      //       type: 'pie',
      //       radius: ['40%', '50%'],
      //       color: ['#D32E32', '#D32E321E'],
      //       hoverAnimation: false,
      //       label: {
      //         normal: {
      //           show: false,
      //           formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  ',
      //           backgroundColor: '#eee',
      //           borderColor: '#aaa',
      //           borderWidth: 1,
      //           borderRadius: 4,
      //           rich: {
      //             a: {
      //               color: '#999',
      //               lineHeight: 25,
      //               align: 'center',
      //               fontSize: 16
      //             },
      //             hr: {
      //               borderColor: '#aaa',
      //               width: '100%',
      //               borderWidth: 0.5,
      //               height: 0
      //             },
      //             b: {
      //               fontSize: 16,
      //               lineHeight: 33
      //             }
      //           }
      //         }
      //       },
      //       data: [
      //         {value: 2000, name: '上月用水量'},
      //         {value: 1000, name: 'aaa'}
      //       ]
      //     },
      //     {
      //       name: '用水统计',
      //       type: 'pie',
      //       radius: ['30%', '40%'],
      //       color: ['#BAF84D', '#BAF84D1E'],
      //       hoverAnimation: false,
      //       label: {
      //         normal: {
      //           show: false,
      //           formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  ',
      //           backgroundColor: '#eee',
      //           borderColor: '#aaa',
      //           borderWidth: 1,
      //           borderRadius: 4,
      //           rich: {
      //             a: {
      //               color: '#999',
      //               lineHeight: 25,
      //               align: 'center',
      //               fontSize: 16
      //             },
      //             hr: {
      //               borderColor: '#aaa',
      //               width: '100%',
      //               borderWidth: 0.5,
      //               height: 0
      //             },
      //             b: {
      //               fontSize: 16,
      //               lineHeight: 33
      //             }
      //           }
      //         }
      //       },
      //       data: [
      //         {value: 1000, name: '本月用水量'},
      //         {value: 200, name: 'bbb'}
      //       ]
      //     },
      //     {
      //       name: '用水统计',
      //       type: 'pie',
      //       radius: ['20%', '30%'],
      //       color: ['#5AC4DA', '#5AC4DA1E'],
      //       hoverAnimation: false,
      //       tooltip: false,
      //       visualMap: {
      //         max: 100
      //       },
      //       label: {
      //         normal: {
      //           show: false,
      //           formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  ',
      //           backgroundColor: '#eee',
      //           borderColor: '#aaa',
      //           borderWidth: 1,
      //           borderRadius: 4,
      //           rich: {
      //             a: {
      //               color: '#999',
      //               lineHeight: 25,
      //               align: 'center',
      //               fontSize: 16
      //             },
      //             hr: {
      //               borderColor: '#aaa',
      //               width: '100%',
      //               borderWidth: 0.5,
      //               height: 0
      //             },
      //             b: {
      //               fontSize: 16,
      //               lineHeight: 33
      //             }
      //           }
      //         }
      //       },
      //       data: [
      //         {value: 10, name: '昨日用水量'},
      //         {value: 100, name: 'ccc'}
      //       ]
      //     }
      //   ]
      // }
      echartOptions: {
        title: {
          text: '图表统计数据',
          left: 'center',
          textStyle: {
            fontSize: 20
          }
        },
        legend: {
          data: ['昨日用水量', '本月用水量', '上月用水量', '月抄见率', '月异常率'],
          top: 50,
          textStyle: {
            fontSize: 15
          }
        },
        series: [
          {
            name: '抄见比例',
            type: 'pie',
            selectedMode: 'single',
            radius: [0, '40%'],
            center: ['30%', '50%'],
            color: ['#6AB0B8', '#334B5C'],
            label: {
              normal: {
                position: 'inner',
                fontSize: 16
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              {value: 0, name: '月抄见率'},
              {value: 0, name: '月异常率'}
            ]
          },
          {
            name: '用水统计',
            type: 'pie',
            radius: ['30%', '40%'],
            center: ['70%', '50%'],
            color: ['#D32E32', '#D32E321E'],
            hoverAnimation: false,
            label: {
              normal: {
                color: '#000',
                position: 'inside'
                // show: false
              }
            },
            data: [
              {value: 0, name: '上月用水量'},
              {value: 0, name: '   '}
            ]
          },
          {
            name: '用水统计',
            type: 'pie',
            radius: ['20%', '30%'],
            center: ['70%', '50%'],
            color: ['#BAF84D', '#BAF84D1E'],
            hoverAnimation: false,
            label: {
              normal: {
                color: '#000',
                position: 'inside'
                // show: false
              }
            },
            data: [
              {value: 0, name: '本月用水量'},
              {value: 0, name: '  '}
            ]
          },
          {
            name: '用水统计',
            type: 'pie',
            radius: ['10%', '20%'],
            center: ['70%', '50%'],
            color: ['#5AC4DA', '#5AC4DA1E'],
            hoverAnimation: false,
            label: {
              normal: {
                color: '#000',
                position: 'inside'
                // show: false
              }
            },
            data: [
              {value: 0, name: '昨日用水量'},
              {value: 0, name: ' '}
            ]
          }
        ]
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      fetch({
        url: '/nb/wss/getData',
        params: {}
      }).then(data => {
        console.log(data)
        if (data.id != null) {
          let basicMax = data.count * 2
          let monthMax = basicMax * 30 * data.subdistCount  // 月最大用水量
          let ldMax = basicMax * data.subdistCount  // 日最大用水量
          let monthSum = 0
          let lmSum = 0
          let ldSum = 0
          // 上月用水比例
          if (data.lmWaterConsumption >= (monthMax)) {
            lmSum = data.lmWaterConsumption
          } else {
            lmSum = monthMax - data.lmWaterConsumption
          }
          // 本月用水比例
          if (data.monthWaterConsumption >= (monthMax)) {
            monthSum = data.monthWaterConsumption
          } else {
            monthSum = monthMax - data.monthWaterConsumption
          }
          // 昨日用水比例
          if (data.ldWaterConsumption >= (ldMax)) {
            ldSum = data.ldWaterConsumption
          } else {
            ldSum = ldMax - data.ldWaterConsumption
          }
          this.waterData = {
            '0': [
              {
                id: 'subdistCount',
                name: '小区总数',
                data: data.subdistCount
              },
              {
                id: 'count',
                name: '用户总数',
                data: data.count
              },
              {
                id: 'ldReadRate',
                name: '昨日抄见率',
                data: data.ldReadRate + '%'
              },
              {
                id: 'mReadRate',
                name: '月抄见率',
                data: data.mReadRate + '%'
              }
            ],
            '1': [
              {
                id: 'ldWaterConsumption',
                name: '昨日用水量',
                data: data.ldWaterConsumption + 'm³'
              },
              {
                id: 'lmWaterConsumption',
                name: '本月用水量',
                data: data.monthWaterConsumption + 'm³'
              },
              {
                id: 'monthWaterConsumption',
                name: '上月用水量',
                data: data.lmWaterConsumption + 'm³'
              }
            ]
          }
          this.echartOptions.series[0].data = [
            {value: data.mReadRate, name: '月抄见率'},
            {value: 100 - data.mReadRate, name: '月异常率'}
          ]
          this.echartOptions.series[1].data = [
            {value: data.lmWaterConsumption, name: '上月用水量'},
            {value: lmSum, name: '   '}
          ]
          this.echartOptions.series[2].data = [
            {value: data.monthWaterConsumption, name: '本月用水量'},
            {value: monthSum, name: '  '}
          ]
          this.echartOptions.series[3].data = [
            {value: data.ldWaterConsumption, name: '昨日用水量'},
            {value: ldSum, name: ' '}
          ]
        } else {
          this.$message({
            message: '暂无数据',
            showClose: true,
            type: 'warning'
          })
        }
        this.initChart()
      })
    },
    initChart () {
      this.dCharts = Echarts.init(document.getElementById('dataChart'))
      this.dCharts.setOption(this.echartOptions)
    }
  },
  computed: {
    liStyle () {
      return function (arg) {
        // return 'width:' + (this.tabWidth - 800) + 'px;' + 'height:' + (this.tabHeight - 180) + 'px;' + 'background:' + this.bgColor[arg] + ';'
        return 'width:300px;' + 'height:auto;' + 'background:' + this.bgColor[arg] + ';'
      }
    }
  }
}
</script>

<style lang="sass">
  #water-data
    float: left;
    width: 300px;
    height: 100%;
    margin-top: 10px;
    margin-left: 30px;
  #water-data > li
    padding: 5px 0 10px 0;
    box-sizing: border-box;
    border-radius: 5px;
    display: block;
    color: #FFF;
    overflow: hidden;
    margin-bottom: 30px;
  #water-data > li > p
    width: 100%;
    font-size: 16px;
    overflow: hidden;
    height: 50px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    margin: 0;
    box-sizing: border-box;
    padding: 0 20px;
  #water-data > li > p > span
    display: block;
    width: 85px;
    float: left;
    height: 48px;
    line-height: 48px;
  #water-data > li > p > span + span
    float: right
    box-sizing: border-box;
    text-align: right;
  #dataChart
    float: right;
    width: calc(100% - 330px);
    height: 100%;
    padding: 5px;
</style>



// WEBPACK FOOTER //
// waterStatisticsSummary.vue?560ce680